module.exports = __webpack_public_path__ + "static/media/DubaiW23-Light.2bb30124.woff";